module.exports = __webpack_public_path__ + "static/img/main-preview-desktop-share.45f646db.svg";